import React from 'react';

import {Container, Loader, Loading} from './styles';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  onClick?: (e?: any) => void;
  widthMode?: 'expand' | 'fit-content';
  size?: 'small' | 'default' | 'extra-small';
  loading?: boolean;
  danger?: boolean;
  permission?: string;
  visible?: boolean;
  icon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  widthMode = 'fit-content',
  size = 'default',
  loading,
  onClick,
  permission,
  visible = true,
  form = 'form',
  icon,
  ...props
}) => {
  const {isAllowed} = useAccessControls();

  const clickButton = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick != undefined) {
      e.stopPropagation();
      onClick(e);
    }
  };

  if ((permission && !isAllowed(permission)) || !visible) return null;

  return (
    <Container
      disabled={loading}
      type="submit"
      onClick={(event) => clickButton(event)}
      {...{widthMode, size, ...props, form}}>
      {icon}
      {props.title}
      {loading && (
        <Loader danger={props.danger}>
          <Loading />
        </Loader>
      )}
    </Container>
  );
};

export default Button;
